import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q2rp7x96kv: FaireBrandEntity = {
  token: "b_q2rp7x96kv",
  type: "brand",
  name: "GoldFi",
  avatarUrl:
    "https://cdn.faire.com/fastly/58be103b6938231174048276cb00ec664a522d1b5e5eee761f20379de7c50071.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fbc25c3479170a67c40fb8d9585915042fb512724996fd79c14f0e8eeeccc302.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/58be103b6938231174048276cb00ec664a522d1b5e5eee761f20379de7c50071.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fbc25c3479170a67c40fb8d9585915042fb512724996fd79c14f0e8eeeccc302.jpeg",
  location: "Miami Shores, FL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 459,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to GoldFi, where luxury and quality intertwine in every meticulously crafted piece. With over two decades of manufacturing expertise, we take immense pride in delivering the finest gold-filled jewelry to boutique owners and gift shops like yours. Our commitment to excellence ensures that each creation meets the highest quality standards, offering unparalleled craftsmanship at the perfect price point.\n\nAt GoldFi, we are more than just jewelry manufacturers; we are artisans dedicated to elevating your brand. Our 18k gold-filled pieces exude timeless elegance and sophistication, captivating your clientele with exquisite designs. Our collection caters to every taste and style, from classic staples to bespoke creations. With us as your partner, you can trust that your boutique will offer nothing but the best. Contact us today to discover how we can enhance your offerings and become your trusted source of luxury jewelry.\n\nNote: As a white-label manufacturer, our products ship unbranded in clear resealable poly bags. \n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.903Z",
    importedBy: "entity-db-cli",
  },
};
